'use strict';

exports.__esModule = true;

var _BaseComponentPropTypes = require('../../propTypes/BaseComponentPropTypes');

var _BaseComponentPropTypes2 = _interopRequireDefault(_BaseComponentPropTypes);

var _StyleSheetPropType = require('../../propTypes/StyleSheetPropType');

var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);

var _TextStylePropTypes = require('./TextStylePropTypes');

var _TextStylePropTypes2 = _interopRequireDefault(_TextStylePropTypes);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule TextPropTypes
 * 
 */

var TextPropTypes = Object.assign({}, _BaseComponentPropTypes2.default, {
  accessibilityRole: (0, _propTypes.oneOf)(['button', 'heading', 'label', 'link', 'listitem']),
  children: _propTypes.any,
  numberOfLines: _propTypes.number,
  onLayout: _propTypes.func,
  onPress: _propTypes.func,
  selectable: _propTypes.bool,
  style: (0, _StyleSheetPropType2.default)(_TextStylePropTypes2.default)
});

exports.default = TextPropTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/components/Text/TextPropTypes.js
// module id = 88
// module chunks = 0